<template>
  <b-modal
    ref="blockedModal"
    title="Không thể hoàn duyệt"
    ok-only
    ok-title="Đã hiểu"
    ok-variant="secondary"
    size="lg"
  >
    <b-alert show variant="danger" class="mb-3">
      Phiếu này không thể hoàn duyệt vì có {{ blockedPeriods.length }} kỳ vượt
      số tiền còn lại hoặc đã bị khóa. Vui lòng xử lý các kỳ bên dưới trước khi
      hoàn duyệt.
    </b-alert>

    <b-table
      :items="rows"
      :fields="fields"
      bordered
      small
      class="mb-0"
      v-if="blockedPeriods && blockedPeriods.length"
    >
      <template #cell(reason)="{ item }">
        <b-badge :variant="item.reason === 'NEGATIVE_BALANCE' ? 'warning' : 'secondary'">
          {{ reasonLabel(item.reason) }}
        </b-badge>
      </template>
      <template #cell(detail)="{ item }">
        <template v-if="item.reason === 'NEGATIVE_BALANCE'">
          <div>
            Kỳ {{ item.label }}: yêu cầu hoàn
            <strong>{{ formatAmount(item.requestAmount) }} đ</strong>
          </div>
          <div>
            nhưng chỉ còn
            <strong>{{ formatAmount(item.remainingAmount) }} đ</strong>
          </div>
        </template>
        <span v-else-if="item.reason === 'LOCKED'" class="text-muted">
          Kỳ đã chốt sổ kế toán
        </span>
        <span v-else class="text-muted">—</span>
      </template>
    </b-table>
  </b-modal>
</template>

<script>
// RevokeBlockedModal — modal cảnh báo các kỳ bị block khi user định hoàn duyệt.
// Khác với confirm modal thường: chỉ có nút "Đã hiểu", không có confirm action.
// Override 2026-06-18 lần 3: reason 'USED' đã bỏ; thay bằng 'NEGATIVE_BALANCE'
// (cho phép hoàn duyệt kể cả khi đã có chi tiêu, miễn số dư không âm).
export default {
  name: 'RevokeBlockedModal',
  props: {
    blockedPeriods: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    fields() {
      return [
        { key: 'label', label: 'Kỳ', thStyle: { width: '20%' }, class: 'text-center' },
        { key: 'reason', label: 'Lý do', thStyle: { width: '25%' }, class: 'text-center' },
        { key: 'detail', label: 'Chi tiết', thStyle: { width: '55%' } },
      ];
    },
    rows() {
      return (this.blockedPeriods || [])
        .slice()
        .sort((a, b) => a.year * 12 + a.month - (b.year * 12 + b.month))
        .map((p) => ({
          ...p,
          label: `${String(p.month).padStart(2, '0')}/${p.year}`,
        }));
    },
  },
  methods: {
    open() {
      this.$refs.blockedModal && this.$refs.blockedModal.show();
    },
    hide() {
      this.$refs.blockedModal && this.$refs.blockedModal.hide();
    },
    reasonLabel(r) {
      if (r === 'NEGATIVE_BALANCE') return 'Vượt số dư còn lại';
      if (r === 'LOCKED') return 'Kỳ đã khóa';
      return r || 'Không xác định';
    },
    formatAmount(val) {
      const n = Number(val) || 0;
      return n.toLocaleString('vi-VN');
    },
  },
};
</script>
